export const SPEAKERS_DATA = [
	{
		name: "Dr. A.C.Shanmugam",
		topic: "Chief Patron",
		avatar_url: require("../assets/images/speakers/chairman.jpg").default,
		institution: "RRGI",
		roles: "Founder Chancellor & Chairman",
		featured_speaker: true,
		social_media: {
			 linkedin: "",
		},
	},
	{
		name: "Sri. A.C.S Arun Kumar",
		topic: "Co-Patron",
		avatar_url: require("../assets/images/speakers/vc.jpg").default,
		institution: "RRGI",
		roles: "President",
		featured_speaker: true,
		social_media: {
			 linkedin: "",
		},
	},
	{
		name: "Dr. Balakrishna Rayanki",
		topic: "Principal of CSE",
		avatar_url: require("../assets/images/speakers/principal.jpg").default,
		institution: "RRCE",
		roles: "Principal",
		featured_speaker: true,
		social_media: {
			 linkedin: "https://www.linkedin.com/in/dr-balakrishna-rayanki-a78b72b/",
		},
	},
	{
		name: "Mrs. Rathymol K. R",
		topic: "Chief Guest",
		avatar_url: require("../assets/images/speakers/rathymol.jpg").default,
		institution: "DRDO ",
		roles: "Senior Scientist",
		featured_speaker: true,
		social_media: {
			 linkedin: "",
		},
	},
	{
		name: "Dr. Usha S",
		topic: "HoD Dept. of CSE",
		avatar_url: require("../assets/images/speakers/hod.jpg").default,
		institution: "RRCE",
		roles: "HoD Dept. of CSE, Dean R&D", 
		featured_speaker: true,
		social_media: {
			 linkedin: "",
		},
	},
];
